export const NotFound = (props) => {
    return (
        <>
            <h1>Not Found</h1>
            <h4>HTTP Status {props.status}</h4>
        </>
    )
};